/**
 * MAP (in-file navigation graph — keep in sync with code):
 *   role:     lib — M14 F3: an invoice line name built from a tenant template
 *             (option_field.invoice_line_default, e.g. «{{trattamento}} ({{pacchetto}})») leaves «()» when the
 *             placeholder in the brackets is empty: «Tecarterapia ()». withoutEmptyBrackets drops an empty «( )» and
 *             the spaces before it; a name with no empty brackets is returned untouched (same string); a name made
 *             only of empty brackets becomes '' (the line check then asks for a description).
 *   used-by:  beebee-base services/new-record-factory.js (getInvoiceLineDefault), beebeeboard-medical
 *             components/event-popup-view.js (replacePlaceholder) — generated names, both UIs;
 *             beebee-component-base-invoice lib/invoice-line-name.js (display of already-stored names, nuova detail)
 *   tests:    tests/unit/lib/invoice-line-name-test.js
 */
const EMPTY_PARENS = /\s*\(\s*\)/g;

/** «Tecarterapia ()» → «Tecarterapia»; «Seduta (12/10)» unchanged; null / '' / non-strings unchanged. */
function withoutEmptyBrackets(name) {
  if (typeof name !== 'string' || !/\(\s*\)/.test(name)) return name;
  const stripped = name.replace(EMPTY_PARENS, '').replace(/ {2,}/g, ' ').trim();
  // A name that is nothing but empty brackets becomes empty on purpose: «()» is never a valid line name, and the
  // empty name is caught by the line check («una riga senza descrizione») so the user writes one. (Keeping «()»
  // here put it back in every blank new line of «Nuova fattura».)
  return stripped;
}

export { withoutEmptyBrackets };
//# sourceMappingURL=invoice-line-name.js.map
